import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { IconSearch } from '@tabler/icons-react';
import { Input, Modal } from '@hana/ui';
import { findItems, EXACT } from './nav';
import type { Zone } from './zone';
import s from './shell.module.css';
import { useT } from '@hana/i18n';

/** Tìm nhanh (Ctrl K) — bản đầu: nhảy tới màn trong menu của vùng (tìm không dấu). Tìm job / khách để sau. */
export function QuickFind({ open, onOpenChange, zone }: { open: boolean; onOpenChange: (o: boolean) => void; zone: Zone }) {
  const t = useT();
  const [q, setQ] = useState('');
  const [i, setI] = useState(0);
  const rows = findItems(zone, q).slice(0, 8);
  const close = () => {
    onOpenChange(false);
    setQ('');
    setI(0);
  };
  return (
    <Modal open={open} onOpenChange={(o) => (o ? onOpenChange(true) : close())} title={t('common.search')}>
      <Input
        aria-label={t('shell.findScreen')}
        icon={<IconSearch size={15} />}
        placeholder={t('shell.findScreenPh')}
        value={q}
        onChange={(e) => {
          setQ(e.target.value);
          setI(0);
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown') setI(Math.min(i + 1, rows.length - 1));
          if (e.key === 'ArrowUp') setI(Math.max(i - 1, 0));
          if (e.key === 'Enter') (document.querySelector(`[data-qf="${i}"]`) as HTMLElement | null)?.click();
        }}
      />
      <div className={s.qfList} role="listbox" aria-label={t('shell.results')}>
        {rows.length === 0 && <div className={s.qfEmpty}>{t('shell.noScreen', { q })}</div>}
        {rows.map((r, k) => (
          <Link activeOptions={EXACT} key={r.key} to={r.to} className={s.qfItem} data-qf={k} data-on={k === i} role="option" aria-selected={k === i} onClick={close}>
            <span>{r.label}</span>
            {r.group && <span>{r.group}</span>}
          </Link>
        ))}
      </div>
    </Modal>
  );
}
